function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModernEclipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: "239px",
    viewBox: "0 0 239 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 233.692 119.312 C 233.692 182.437 182.576 233.628 119.5 233.628 C 56.423 233.628 5.307 182.437 5.307 119.312 C 5.307 56.186 56.423 4.995 119.5 4.995 C 182.576 4.995 233.692 56.186 233.692 119.312 Z",
    fill: "none",
    stroke: "#3F3F3F",
    style: {
      strokeLinecap: "round",
      strokeMiterlimit: 5.16,
      paintOrder: "stroke",
      strokeWidth: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModernEclipse);
export default __webpack_public_path__ + "static/media/modern-eclipse.939b645eb76c8b225dd174b46d7ebfac.svg";
export { ForwardRef as ReactComponent };